import React, { useState } from "react";
import Logo from "../../assets/images/landingpage/logo.png";
import { X } from "react-feather";

const MobileSidebar = ({ isOpen, onClose, menus }) => {
  const [active, setActive] = useState(null);

  const toggleMenu = (i) => {
    setActive(active === i ? null : i);
  };

  return (
    <>
      <div
        className={`lanp-overlay ${isOpen ? "show" : ""}`}
        onClick={onClose}
      ></div>

      <div className={`lanp-sidebar ${isOpen ? "open" : ""}`}>
        <div className="lanp-sidebar-header d-flex justify-content-between align-items-center">
          <a href="/home">
            <img src={Logo} alt="logo" width={70} />
          </a>

          <button onClick={onClose}>
            <X size={25} />
          </button>
        </div>

        <div className="lanp-sidebar-body">

          {menus.map((menu, i) => (
            <div key={i}>
              {menu.items ? (
                <>
                  <div
                    className="lanp-sidebar-title d-flex justify-content-between"
                    onClick={() => toggleMenu(i)}
                  >
                    {menu.title}
                    <span>{active === i ? "-" : "+"}</span>
                  </div>

                  <div
                    className={`lanp-sidebar-collapse ${active === i ? "show" : ""
                      }`}
                  >
                    {menu.items.map((item, j) => {
                      const Icon = item.icon;

                      return (
                        <div className="lanp-sidebar-item d-flex" key={j}>
                          <a href={item.path} className="d-flex text-dark">


                            <div className="lanp-icon me-2">
                              {Icon && <Icon size={18} />}
                            </div>
                            <div>
                              <h6>{item.title}</h6>
                              <small>{item.desc}</small>
                            </div>
                          </a>
                        </div>
                      );
                    })}
                  </div>
                </>
              ) : (
                <a href={menu.link} className="lanp-sidebar-title text-dark d-block">
                  {menu.title}
                </a>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default MobileSidebar;